import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import React from 'react'
import { connect } from 'react-redux'
import { AppLink } from '@chegg-wt/core/components/AppLink'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { activeCitationSelector } from '@chegg-wt/core/state/citation/selectors'
import * as Styled from './styles'

interface Props {
  citation: Citation
  style: string
  sourceType: string
  searchQuery: string
}

const EvalContent: React.FunctionComponent<Props> = ({
  citation,
  style,
  sourceType,
  searchQuery,
}) => {
  const { toNewCitation, toSourceSelection } = useRoutesContext()
  const BACK_BUTTON = 'Back to results'
  const CONTINUE_BUTTON = 'Continue'

  return (
    <Styled.NavBorder>
      <Styled.Container>
        {citation && Object.keys(citation).length !== 0 && (
          <AppLink
            route={toNewCitation({
              style,
              sourceType,
            })}
          >
            <Styled.ContinueButton data-test="submit-eval">
              {CONTINUE_BUTTON}
            </Styled.ContinueButton>
          </AppLink>
        )}
        <AppLink
          route={toSourceSelection({
            style,
            sourceType,
            query: encodeURIComponent(searchQuery),
          })}
        >
          <Styled.BackButton data-test="back-to-search-results">
            {BACK_BUTTON}
          </Styled.BackButton>
        </AppLink>
      </Styled.Container>
    </Styled.NavBorder>
  )
}

const mapStateToProps = (state) => ({
  citation: activeCitationSelector(state),
})

export default connect(mapStateToProps)(EvalContent)
